<div class="title-row regular-14 text-color-soft" [ngClass]="{'open': !collapsed()}" (click)="collapsed.set(!collapsed())">
  <q-svg-wrapper class="arrow" iconPath="project-icons/chevron-left"></q-svg-wrapper>
  {{title()}}
</div>
@if (!collapsed()) {
  <div class="content">
    <ng-content></ng-content>
  </div>
}
